import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-receivals-action',
  templateUrl: './receivals-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ReceivalsActionComponent {
  @Input() product!: IProduct;

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private router: Router,
  ) {}

  onOpenReceivals(): void {
    const navigationExtras: NavigationExtras = { state: { product: this.product } };
    this.router.navigate(['product/receivals'], navigationExtras);
  }
}
